import { ArticleCard } from 'components/press/PressCard/PressCard';
import popsugar from './logos/popsugar.png';
import mashable from './logos/mashable.png';
import forbes from './logos/forbes.png';
import womanAndHome from './logos/woman-and-home.png';
import marieClaire from './logos/marie-claire.png';
import chronicle from './logos/chronicle.png';
import inc from './logos/inc.png';
import esquire from './logos/esquire.png';
import stylist from './logos/stylist.png';
import theTimes from './logos/the-times.png';
import metro from './logos/metro.png';
import self from './logos/self.png';
import pcMag from './logos/pc-mag.png';
import nyTimes from './logos/ny-times.png';
import cnn from './logos/cnn.png';
import reuters from './logos/reuters.png';

const articles: ArticleCard[] = [
  {
    cardType: 'article',
    logoSrc: popsugar,
    company: 'PopSugar',
    title: "I Hiked For the First Time at 27 — Here's What Every Newbie Should Know",
    date: 'February 20, 2023',
    href: 'https://www.popsugar.com/fitness/first-time-hiking-tips-49090125'
  },
  {
    cardType: 'article',
    logoSrc: mashable,
    company: 'Mashable',
    title: 'The 23 most useful free iPhone apps, according to Reddit',
    date: 'December 24, 2022',
    href: 'https://mashable.com/article/best-free-iphone-apps-reddit'
  },
  {
    cardType: 'article',
    logoSrc: forbes,
    company: 'Forbes',
    title: 'Holiday Gift Guide 2022: Best Gifts For Hikers',
    date: 'Nov 18, 2022',
    href: 'https://www.forbes.com/sites/micheleherrmann/2022/11/18/holiday-gift-guide-2022-best-gifts-for-hikers/?sh=4373785b8b9e'
  },
  {
    cardType: 'article',
    logoSrc: womanAndHome,
    company: 'Woman&Home',
    title: "Does walking 30 minutes a day make a difference? Here's what I learned after one month",
    date: 'December 12, 2022',
    href: 'https://www.womanandhome.com/health-wellbeing/walking-30-minutes-a-day/'
  },
  {
    cardType: 'article',
    logoSrc: marieClaire,
    company: 'Marie Claire',
    title: "I'm a Health Editor: in my opinion, these are the only 13 fitness apps worth your time or money",
    date: 'Nov 30, 2022',
    href: 'https://www.marieclaire.co.uk/life/health-fitness/fitness-apps-98363'
  },
  {
    cardType: 'article',
    logoSrc: chronicle,
    company: 'San Francisco Chronicle',
    title: 'The 10 best hiking trails in the Bay Area, according to 600,000 reviews',
    date: 'Nov 1, 2022',
    href: 'https://www.sfchronicle.com/projects/guide/best-bay-area-hikes-alltrails/'
  },
  {
    cardType: 'article',
    logoSrc: inc,
    company: 'Inc.',
    title: 'Companies Have a Disconnection Problem: Use Shared Experiences to Bring People Together Again',
    date: 'Sep 6, 2022',
    href: 'https://www.inc.com/young-entrepreneur-council/companies-have-a-disconnection-problem-use-shared-experiences-to-bring-people-together-again.html'
  },
  {
    cardType: 'article',
    logoSrc: esquire,
    company: 'Esquire',
    title: 'The 50 Most Incredible Hiking Trails in Every State',
    date: 'Sep 1, 2022',
    href: 'https://www.esquire.com/lifestyle/g41044871/best-hiking-trails-in-every-state/'
  },
  {
    cardType: 'article',
    logoSrc: stylist,
    company: 'Stylist',
    title: '10 of the best hikes for all abilities in the UK, according to women',
    date: 'July, 2022',
    href: 'https://www.stylist.co.uk/fitness-health/workouts/10-best-hikes-uk/693437'
  },
  {
    cardType: 'article',
    logoSrc: theTimes,
    company: 'The Times',
    title: "Summer's new fitness craze? Hike-to-swim",
    date: 'July 22, 2022',
    href: 'https://www.thetimes.co.uk/article/summers-new-fitness-craze-hike-to-swim-q8w3bdx95'
  },
  {
    cardType: 'article',
    logoSrc: metro,
    company: 'Metro',
    title: 'The top 10 most accessible UK walking trails',
    date: 'July 7, 2022',
    href: 'https://metro.co.uk/2022/07/07/the-top-10-most-accessible-uk-walking-trails-16960797/'
  },
  {
    cardType: 'article',
    logoSrc: self,
    company: 'SELF',
    title: "15 Hiking Apps That'll Help You Find Your New Favorite Trail",
    date: 'June 8, 2022',
    href: 'https://www.self.com/story/best-hiking-apps'
  },
  {
    cardType: 'article',
    logoSrc: pcMag,
    company: 'PC Mag',
    title: '9 Must-Have Apps to Keep You Active During the Workday',
    date: 'May 11, 2022',
    href: 'https://www.pcmag.com/picks/must-have-apps-to-keep-you-active-during-the-workday'
  },
  {
    cardType: 'article',
    logoSrc: nyTimes,
    company: 'New York Times',
    title: 'I Visited 14 National Parks Last Year. Here Are the Apps I Used to Plan and Pull Off Those Trips.',
    date: 'April 21, 2022',
    href: 'https://www.nytimes.com/wirecutter/blog/best-apps-for-visiting-national-parks/'
  },
  {
    cardType: 'article',
    logoSrc: cnn,
    company: 'CNN',
    title: 'Park-ranger-approved tips for visiting national parks',
    date: 'April 19, 2022',
    href: 'https://edition.cnn.com/cnn-underscored/outdoors/national-park-visiting-tips'
  },
  {
    cardType: 'article',
    logoSrc: reuters,
    company: 'Reuters',
    title: 'PE firm Permira invests $150 mln in hiking app AllTrails',
    date: 'Nov 17, 2021',
    href: 'https://www.reuters.com/business/finance/pe-firm-permira-invests-150-mln-hiking-app-alltrails-2021-11-17/'
  }
];

export default articles;
